import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { extractPureTextFromRichText, Typography } from 'seagull';
import ExtraClause from '~/components/AgreementStudioPage/AgreementStudioModal/ExtraClause/ExtraClause';
import { TemplateVariablesProvider } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariablesContext';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { PersistTemplateVariableValues } from '../PersistTemplateVariableValues';
const EMPTY_TEXT_FIELDS = [];
export const AgreementNoteModalContent = (param)=>{
    let { draft, setDraft, contact, worksAt } = param;
    const form = useForm({
        defaultValues: {
            extraClause: draft.extraClause() || ''
        }
    });
    const richTextFields = useMemo(()=>[
            draft.extraClause()
        ], [
        draft
    ]);
    const [showAgreementSettingsWarning, setShowAgreementSettingsWarning] = useState(false);
    return /*#__PURE__*/ _jsxs(TemplateVariablesProvider, {
        contact: contact,
        worksAt: worksAt,
        agreementName: draft.title(),
        effectiveDate: draft.effectiveDateAsDate(),
        initialTemplateVariableValues: draft.templateVariableValues(),
        textFields: EMPTY_TEXT_FIELDS,
        richTextFields: richTextFields,
        children: [
            /*#__PURE__*/ _jsx(PersistTemplateVariableValues, {
                setDraft: setDraft
            }),
            /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, form), {
                children: /*#__PURE__*/ _jsx(ExtraClause, {
                    showAgreementSettingsWarning: showAgreementSettingsWarning,
                    onValidation: (isValid)=>{
                        if (isValid) return;
                        setShowAgreementSettingsWarning(true);
                    },
                    hideLabel: true,
                    onChange: (v)=>{
                        setDraft((prev)=>prev.setExtraClause(JSON.stringify(v)));
                    }
                })
            }))
        ]
    });
};
export default function AgreementNoteCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip, contact, worksAt } = param;
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const onClick = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: draftCellsTexts.agreementNote(),
                    testId: 'edit-agreement-note-modal',
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(AgreementNoteModalContent, {
                        draft: draft,
                        setDraft: setDraft,
                        contact: contact,
                        worksAt: worksAt
                    })
                };
            }
        });
    const extraClause = draft.extraClause();
    const pureText = useMemo(()=>extractPureTextFromRichText(extraClause).trim(), [
        extraClause
    ]);
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-agreement-note-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "agreement-note-".concat(index),
            skin: pureText ? 'standard' : 'secondary',
            children: pureText || editTableTexts.notSet()
        })
    });
}
